import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagCV(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtCAMAAAAun0N9AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURQc9lPfQNvX19PLy8gtIq/39/c0jLglDoQdAmwpFpvT08z5iid29P219caGdXPjuyfbcceR+Md9GZ/kAAAF/SURBVEjH1ZXpsoMgDIWTbkBZ1Pd/2RoETKLVqvfP/aya7WBnHDnwuAb8d71zDzqmn8uUuOatx+qtC1VUlSLnqai3JrhrXNYbZ5wz9chQhaDcrRylnkMwHLbIJvMMmOM4tsQZPQeMvXSANXSnMN81pvXLlJWzsBi34gGt3q7G8iLYa1zXQ1mlnFDWhNqFuazS/JsaIzafuRaTt5BSLL1ZJ+N2QmsRMSAGiDheYx2oWBmLXoGEo97TDT0f/LqS1ufn0v8IcIIYa+SPi0MSqQ9hZ5GnoEfseN4h9s8tpP6GSz3eftfTuOzrBRf6F2dAHF47FYnUv0LQA8OmXOsPA29J16m8VwUF3AX0/t73d8vp/fE8MxZabanvt/IFyn/pq4lzSt+SP+Tfafx6RJZ2/VtaasLofPQuX3xKJ/zTBJzwv/incr0x9Fj1wldXjPSLf/lEW1jyv/jX5CXNKph3cF/SvtJ6IMxnzcEO+cdhO1G7kd3bXdewai//tsnPsYW/4gPuXT4A6dLKQQAAAABJRU5ErkJggg==",
    alt: "CV"
  }, props));
}